import ApiService from './ApiService';

export default class AppointmentApi extends ApiService {
    constructor() {
        super('appointments');
    }

    getAppointments(payload) {
        return this.get('', payload);
    }

    getAppointment(code) {
        return this.get(code);
    }
}
